import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SignIn from "./SignIn/SignIn";
import UserProfile from "./UserProfile/UserProfile";
import Orders from "./Orders/Orders";
import Order from "./Order/Order";
import MyInventory from "./MyInventory/MyInventory";
import Dashboard from "./Dashboard/Dashboard";
import NotFound from "./NotFound/NotFound"; 
import Timeline from "./Timeline/Timeline";
import AccessDenied from "./AccessDenied/AccessDenied"; 


const AppRouter = ({ user, onLogin }) => {
  return (
    <Routes>
      <Route path="/" element={user ? <UserProfile user={user} /> : <Navigate to="/signin" />} />
      <Route path="/signin" element={user ? <UserProfile user={user} /> : <SignIn onLogin={onLogin} />} />
      <Route
        path="/profile"
        element={user ? <UserProfile user={user} /> : <Navigate to="/signin" />}
      />
      <Route path="/orders" element={user ? <Orders user={user} /> : <Navigate to="/signin" />} />
      <Route
        path="/order/:paramOrderNo"
        element={user ? <Order user={user} /> : <Navigate to="/signin" />}
      />

      <Route
        path="/my-inventory"
        element={
          user
            ? (user.role === "tech" || user.role === "warehouseAdmin")
              ? <MyInventory user={user} />
              : <AccessDenied />
            : <Navigate to="/signin" />
        }
      />

      <Route
        path="/dashboard"
        element={
          user
            ? (user.role !== "tech"
              ? <Dashboard user={user} />
              : <AccessDenied />)
            : <Navigate to="/signin" />
        }
      />
      
      <Route
        path="/timeline"
        element={
          user
            ? (user.role === "tech" || user.role === "warehouseAdmin" || user.role === "pm")
              ? <Timeline user={user} />
              : <AccessDenied />
            : <Navigate to="/signin" />
        }
      />

      {/* Catch-all route for undefined paths */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRouter;
